import { Injectable } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { StorageService } from './storage.service';
import { SiteApiService } from './api/site.services';

@Injectable({
  providedIn: 'root',
})
export class SiteService {
  constructor(
    private storageService: StorageService,
    private siteApiService: SiteApiService
  ) {}

  setSelectedSite(selected?: number): Observable<any> {
    const storageSite = this.storageService.getSite();
    const site = storageSite ? storageSite : -1;
    if (selected) {
      return new Observable((observer) => {
        const subscription = this.siteApiService
          .getSite(selected)
          .pipe(
            map((siteData) => ({
              id: siteData.id,
              description: siteData.description,
            }))
          )
          .subscribe({
            error: (error) => {
              observer.error(error);
            },
            complete: () => {
              observer.complete;
              subscription.unsubscribe;
            },
          });
      });
    } else if (site > 0) {
      return of(this.getStorageSite(site));
    } else {
      return this.siteApiService.getSites().pipe(
        map((siteData) => ({
          id: siteData.data[0].id,
          description: siteData.data[0].description,
        }))
      );
    }
  }

  getStorageSite(id: number) {
    const sites = this.storageService.getSites();
    if (sites) {
      for (let i = 0; i < sites.length; i++) {
        if (sites[i].id === id) {
          return sites[i];
        }
      }
    }
    return null;
  }
}
